import React from "react";
import { ResultComparison } from "@learningblocks/storybook-components";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import { HighlightProvider as SharedHighlightProvider } from "@learningblocks/shared-components";
import { useHighlight } from "@learningblocks/shared/glossary";
import { Chart } from "./Chart";
import "./style.scss";

export const ResultsComparisonCharts = (props) => {
  const { onPlainTextClick } =
    React.useContext(SharedHighlightProvider.Context) || useHighlight();

  const onClickHighlight = (contentId, event) => {
    onPlainTextClick(contentId, event);
  };

  const captionData = props.caption
    ? typeof props.caption === "object"
      ? props.caption
      : { text: props.caption }
    : null;

  const captionComponent = captionData ? (
    <div className="results-comparison-charts-caption">
      <RichText {...captionData} onClickHighlight={onClickHighlight} />
    </div>
  ) : null;

  return (
    <ResultComparison
      predictedState={{
        type: "component",
        label: props.predictionData.label,
        component: <Chart {...props.predictionData.content}></Chart>,
      }}
      actualState={{
        type: "component",
        label: props.actualData.label,
        component: <Chart {...props.actualData.content}></Chart>,
      }}
      idealState={{
        type: "component",
        label: props.idealData.label,
        component: <Chart {...props.idealData.content}></Chart>,
      }}
      caption={captionComponent}
    />
  );
};
